import { defineMessage } from 'services/localization';

export const messages = {
    allRequestsName: defineMessage('all_requests'),
    requiresMyDecisionName: defineMessage('requires_my_approval'),
    requiresMyReviewName: defineMessage('requires_my_review'),
    onHold: defineMessage('on_hold'),
};
